import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["RESERVATION_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["RESERVATION_MODULE"],
  },
];

export default routes;
